import {ItemWrapper} from '../models/itemWrapper';

export class ItemWrapperFilter {
    static filter(items: Array<ItemWrapper>, expression, groupValue=''): Array<ItemWrapper> {
        return !expression
            ? items
            : items.filter(i => i.isMatch(expression, groupValue));
    }

    static factory() : Function {
        return ItemWrapperFilter.filter;
    }
}

angular.module('deliveryCreate.app').filter('itemWrapperFilter', ItemWrapperFilter.factory);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/itemsList/filters/itemWrapperFilter.ts
 **/